import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique, sum } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDate, styleDateRange } from '@utils/styles';

interface SuccessfulCutsByCoverageTypeProps {
    dateRange: { startDate: string; endDate: string };
}

export const SuccessfulCutsByCoverageType = ({ dateRange }: SuccessfulCutsByCoverageTypeProps) => {
    const [range, setRange] = useRange('SuccessfulCutsByCoverageType');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.PRODUCTS_SUCCESSFUL_CUTS_BY_COVERAGE_TYPE,
        params: { range, ...dateRange },
    });

    return (
        <BaseReport
            setRange={setRange}
            title={'Successful Cuts by Coverage Type'}
            description={
                'This table shows you the % breakdown of different coverage types that you cut, along with the number of cuts, for all time.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            range={range}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Date', 'Coverage Type', '% of Cuts', 'Successful Cuts'],
                data: data.map((item) => [item.date, item.coverageType, item.coveragePct, item.successfulCuts]),
                summaries: [countUnique, countUnique, average, sum],
                style: [styleDate(range)],
                sort: [dateSort(range), basicSort, basicSort, basicSort],
            }}
        />
    );
};
